import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";
import { checkPermission } from "utils/permissions";

const BASE_URL = API_BASE_URL;
let queryparam = {limit:10000};

/**
 *
 * @param {FetchListParams} params
 * @returns {Promise<FetchBrokerFirmsResponse>}
 */
// export function requestBrokerFirms(params) {
//   /**
//    * @NOTE This limit is hard code for now because we need to implement the sorting nad filterting only at front end.
//    *  In future we may remove it when sorting and filterting is implemented on backend
//    */
//   if(!checkPermission("BROKER", "ADD_NON_IPC")){
//     queryparam.firmType = "IPC";
//   }

//   return fetch.get(`${BASE_URL}/api/app/broker-firm?${params}`);
//   // return fetch.get(`${BASE_URL}/api/app/broker-firm?firmType[in]=[${firmType}]`, {
//   //   params: { limit: 10000 },
//   // });
// }

export function requestBrokerFirms(params) {
  return fetch.get(`${BASE_URL}/api/app/broker-firm`, {
    params: { limit: Number.MAX_SAFE_INTEGER },
  })
}

/**
 *
 * @param {BrokerFirm} firmData
 */
export function requestCreateBrokerFirms(firmData) {
  return fetch.post(`${BASE_URL}/api/app/broker-firm`, {
    ...firmData,
  });
}

/**
 *
 * @param {BrokerFirm} firmData
 */
export function requestUpdateBrokerFirms(firmData) {
  const data = { ...firmData };
  delete data["_id"];
  return fetch.put(`${BASE_URL}/api/app/broker-firm/${firmData._id}`, {
    ...data,
  });
}

export function deleteBrokerFirms(firmData) {
  throw Error("Not implemented");
}
